import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {Category} from '@models/category'
import {deleteRequest, fetchRequest} from '@actions/category'
import CategoryForm from "@components/categories/Form";
import {createRequest, updateRequest} from '@actions/category';
import categoryApi from '@api/category'
import {injectIntl} from 'react-intl';


interface PropsFromState {
  loading: boolean
  data: Category[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  deleteRequest: typeof deleteRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class CategoryFormPage extends React.Component<AllProps> {
  
  state = {
    category : null,
    category_id : this.props.match.params.id,
    is_fetched : false
  };
  
  componentDidMount(){
    if(this.state.category_id){
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    categoryApi.getItem({
        params: {
          id: this.state.category_id,
        }
      })
      .then(({data}) => {
        this.setState({
          category : data
        })
      })
      .catch((error) => console.log(error))
  };
  
  getContent = () => {
    if(this.state.category_id && !this.state.category){
      return null
    }
    
    return (
      <CategoryForm category={this.state.category}
               intl={this.props.intl}
               listUrl={"/categories"}
               history={this.props.history}
               updateRequest={this.props.updateRequest}
               createRequest={this.props.createRequest}/>
    )
  };
  
  render() {
    return (
      <Fragment>
        {this.getContent()}
      </Fragment>
    )
  }
}



const mapStateToProps = ({categories}: ApplicationState) => ({
  loading: categories.loading,
  errors: categories.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CategoryFormPage));



